import * as React from "react";

function SvgUngroupContainerIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M10.9 20h-9c-1 0-1.8-.8-1.8-1.8v-5.1c0-1 .8-1.8 1.8-1.8h9c1 0 1.8.8 1.8 1.8v5.1c0 1-.8 1.8-1.8 1.8zm-9.1-7.4c-.3 0-.5.2-.5.5v5.1c0 .3.2.5.5.5h9c.3 0 .5-.2.5-.5v-5.1c0-.3-.2-.5-.5-.5h-9zM18.2 8.7h-9c-1 0-1.8-.8-1.8-1.8V1.8C7.4.8 8.2 0 9.2 0h9c1 0 1.8.8 1.8 1.8v5.1c0 1-.8 1.8-1.8 1.8zM9.1 1.3c-.3 0-.5.2-.5.5v5.1c0 .3.2.5.5.5h9c.3 0 .5-.2.5-.5V1.8c0-.3-.2-.5-.5-.5h-9z" /></svg>;
}

export default SvgUngroupContainerIcon;